import React, { CSSProperties } from "react";
import { Box, Typography } from "@mui/material";

const styles: { [key: string]: CSSProperties } = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    backgroundColor: "#f9f9f9",
    color: "#333",
  },
  section: {
    marginBottom: "20px",
  },
};

const MultiConsent: React.FC = () => {
  return (
    <Box sx={styles.container}>
      <section style={styles.section}>
        <Typography
          variant="h6"
          sx={{ mt: 0, color: "#0b3452", fontWeight: "bold" }}
        >
          Multi Consent
        </Typography>
        
        <p>
          Multi-consent allows multiple consents to be processed within a single journey.
        </p>

        <p>
          The <code>consentRequestDetailsEncList()</code> method returns a list containing all the consent request details.
        </p>

        <p>
          The response of the <code>consentRequestDetailsEncList()</code> method includes multiple consent details in the payload. 
          The <code>consentRequestList</code> contains several objects, and each object represents the details of a single consent.
        </p>

        <p>
          For each consent, the <code>consentApproveRequest()</code> method is used to either approve or reject it.
        </p>

        <p>
          In the example below, two consent requests are handled in the same journey.
          When the user clicks the "Accept" button, the <code>consentApproveRequest()</code> method is triggered twice — once for each consent.
        </p>

        <Box
          sx={{
            mt: 2,
            mb: 2,
            display: { xs: 'block', md: 'flex' },
            width: '100%',
            maxWidth: '700px',
            justifyContent: 'center',
            alignItems: 'flex-start',
            margin: '0 auto',
            border: { xs: 'none', md: '1px solid black' },
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          {/* Left Column */}
          <Box
            sx={{
              width: { xs: '100%', md: '50%' },
              borderRight: { xs: 'none', md: '1px solid black' },
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                width: '100%',
                textAlign: 'center',
                borderBottom: { xs: 'none', md: '1px solid black' },
                pb: 1,
                mb: 2,
              }}
            >
              <Typography>
                Details of the consent 1
              </Typography>
            </Box>
            <Box
              component="img"
              src="/images/ConsentPage1.png"
              alt="Profile Discovery Image"
              sx={{
                width: '100%',
                maxWidth: '300px',
                height: { xs: '300px', md: '500px' },
                objectFit: 'contain',
                display: 'block',
                mx: 'auto',
              }}
            />
          </Box>
          {/* Right Column */}
          <Box
            sx={{
              width: { xs: '100%', md: '50%' },
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxSizing: 'border-box',
            }}
          >
            <Box
              sx={{
                width: '100%',
                textAlign: 'center',
                borderBottom: { xs: 'none', md: '1px solid black' },
                pb: 1,
                mb: 2,
              }}
            >
              <Typography>
                Details of the consent 2
              </Typography>
            </Box>
            <Box
              component="img"
              src="/images/ConsentPage2.png"
              alt="Profile Discovery Image"
              sx={{
                width: '100%',
                maxWidth: '300px',
                height: { xs: '300px', md: '500px' },
                objectFit: 'contain',
                display: 'block',
                mx: 'auto',
              }}
            />
          </Box>
        </Box>
      </section>
    </Box>
  );
};

export default MultiConsent;

